// extracted by mini-css-extract-plugin
export default {"main":"_0c4e6f35c5 b647b2c334 de55d13646 _8e84852891","title":"fd45e7c355"};